<template>
  <div class="auth-page">
    <v-container class="auth-container">
      <v-card class="auth-card">
        <v-card-title class="text-center text-primary text-h5 font-weight-bold">
          Reset Password
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form @submit.prevent="submit">
            <v-text-field
              v-model="password"
              label="New password"
              type="password"
              outlined
              required
            />
            <v-text-field
              v-model="confirm"
              label="Confirm password"
              type="password"
              outlined
              required
            />
            <v-btn
              type="submit"
              color="primary"
              block
              class="mt-3"
              :loading="loading"
            >
              Reset Password
            </v-btn>
          </v-form>
          <v-alert v-if="error" type="error" dense class="mt-3">
            {{ error }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirm: '',
      loading: false,
      error: '',
      uid: null,
      token: null,
    };
  },
  created() {
    // pull uid and token from URL params
    this.uid = this.$route.params.uid;
    this.token = this.$route.params.token;
  },
  methods: {
    async submit() {
      this.error = '';
      if (this.password !== this.confirm) {
        this.error = "Passwords don't match.";
        return;
      }
      this.loading = true;
      try {
        await axios.post('/api/auth/password/reset/confirm/', {
          uid: this.uid,
          token: this.token,
          new_password1: this.password,
          new_password2: this.confirm,
        });
        this.$router.push({ name: 'LoginPage', query: { reset: 'success' } });
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data) {
          // Flatten serializer errors into a single message
          const messages = Object.values(e.response.data).flat();
          this.error = messages.join(' ') || 'Invalid or expired reset link.';
        } else {
          this.error = 'Invalid or expired reset link.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Full Background Gradient */
.auth-page {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8vh;
  overflow: hidden;
}

/* Centered Container */
.auth-container {
  width: 100%;
  max-width: 450px;
}

/* Card Styling */
.auth-card {
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  width: 100%;
}
.auth-card:hover {
  transform: translateY(-5px);
}
</style>